<script>
import Layout from '@layouts/main.vue'
import baseMixin from '@/mixins/baseMixin'
import idleMixin from '@/mixins/idleMixin'
import BookingListContainer from '@/components/booking/bookingList/booking-list-container.vue'

export default {
  name: 'BookingList',
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'The Booking Listing Page.' }],
    }
  },
  components: {
    Layout,
    BookingListContainer,
  },
}
</script>

<template>
  <Layout>
    <BookingListContainer />
  </Layout>
</template>
